import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

  container: () => {
    return  {
        display: 'flex',
        height: '100vh',
        width: '100%',
      
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'scroll',
    };
  },

  content: ({ commonUIStyles }) => {
    function getHeight () {
      return 'calc(100% - 40px)';
    }
 
    return {
      display: 'flex',
      flexDirection: 'column !important',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden',
      overflowY: 'auto',
      width: '100%',
      height: getHeight(),

    	/* rest of css*/
      // overflowY: 'scroll',
      padding: '0px',

      /* for firefox*/
      scrollbarColor: 'transparent transparent',
      scrollbarWidth: '12px',

      '&::-webkit-scrollbar': {
          width: '12px',
          background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderradius: '5px',
      },

      '&:hover': {
          'scrollbarColor': '#D9D9D9 transparent',
      },

    };
  },

  headerSpace: {
    width: '100%',
    marginBottom: '8px',
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center',
    justifyContent: 'center',
  },

  calendarListPanel: () => {
    return  {
      display: 'flex',
      flexDirection: 'column !important',
      alignItems: 'center',
      // justifyContent: 'center',
      width: '100%',
      // padding: '0 1rem 1rem',
      // minHeight: '344px',
      // marginTop: '16px',
    };
  },

  list: () => {
    return  {
      display: 'flex',
      overflow: 'hidden',
      width: '100%',
      justifyContent: 'center',

    	/* rest of css*/
      overflowY: 'scroll',
      paddingLeft: '17px',
      paddingRight: '5px',
      /* for firefox*/
      scrollbarColor: 'transparent transparent',
      scrollbarWidth: '12px',
      '&::-webkit-scrollbar': {
          width: '12px',
          background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderradius: '5px',
      },
      '&:hover': {
          'scrollbarColor': '#D9D9D9 transparent',
      },
    };
  },

  listContent: () => {
    return  {
      display: 'flex',
      flexWrap: 'wrap',
      width: '463px',
      justifyContent: 'flex-start',
      // alignContent: 'center',
      columnGap: '5px',

      [theme.breakpoints.down('xs')]: {
        width: `calc(100% - 64px)`,
        minWidth: '358px',
      },
    };
  },

  tileBox: () => {
    return  {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '80px',
      height: '80px',
      border: '1px solid #BDBCBE80',
      borderRadius: '12px',

      '&:hover': {
        backgroundColor: '#F7F7F7',
        boxShadow: '0px 4px 4px 0px #00000040',
      },
    };
  },

  tile:  () => {
    
    return  {
      width: '56px',
      height: '56px',
    };
  },

  tileAppleShadow: () => {
    return {
      filter: 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25))',
    };
  },
  
});

export default styles;
export const useStyles = makeStyles(styles);
